import { helper } from '@ember/component/helper';

export default helper(function arrayIncludes([arrayObject = [], item, key]) {
  if (!key) {
    return arrayObject && arrayObject.includes(item);
  }
  // If a key is provided, iterate through the array and check the key values
  return arrayObject.some((_item) => _item[key] === item);
});
